/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{parseFeatureQuery as e}from"./pbfFeatureServiceParser.js";function r(r,t){const{featureResult:o}=e(r,t);return o}export{r as parsePBFFeatureQuery};
